export default __webpack_public_path__ + "static/media/silver-medal.42c1b3cd.svg";